import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { t } from '@/@core/libs/i18n/utils'

export default function useRedeemList() {
  // Use toast
  const toast = useToast()

  const refRedeemListTable = ref(null)

  const msgRedeemList = {
    errorfetchRedeem: t('Error fetching {module} list', t('Redeem')),
    date_time: `${t('Redeem')} » ${t('Date')} ${t('Time')},${t('By')}`,
    coupon: `${t('Coupon')} » ${t('Brand')},${t('Merchant')},${t('Code')},${t('Value')}`,
    refid_reference_point: `${t('Redeem')} » ${t('Ref ID')},${t('Reference')},${t('Point')}`,
    refund_datetime_username: `${t('Refund')} » ${t('Date')} ${t('Time')},${t('By')}`,
    actions: t('Actions'),
  }

  // Table Handlers
  const tableColumns = [
    { key: 'date_time', sortable: true, label: msgRedeemList.date_time },
    { key: 'coupon', sortable: true, label: msgRedeemList.coupon },
    { key: 'refid_reference_point', sortable: true, label: msgRedeemList.refid_reference_point },
    { key: 'refund_datetime_username', sortable: false, label: msgRedeemList.refund_datetime_username },
    { key: 'actions', label: msgRedeemList.actions },
  ]

  const perPage = ref(10)
  const totalRedeems = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [2, 5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('date_time')
  const isSortDirDesc = ref(true)
  const brandFilter = ref(null)
  const merchantFilter = ref(null)
  const codeFilter = ref(null)
  const refidFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refRedeemListTable.value ? refRedeemListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRedeems.value,
    }
  })

  const refetchData = () => {
    refRedeemListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, brandFilter, merchantFilter, codeFilter, refidFilter], () => {
    refetchData()
  })

  const getRedeems = (ctx, callback) => {
    const params = {
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      brand: brandFilter.value,
      merchant: merchantFilter.value,
      code: codeFilter.value,
      refid: refidFilter.value,
    }
    store
      .dispatch('redeem-store/getRedeems', params)
      .then(response => {
        const { redeems, total } = response.data
        callback(redeems)
        totalRedeems.value = total
        localStorage.setItem('filterRedeemList', JSON.stringify(params))
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: msgRedeemList.errorfetchRedeem,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        },
        {
          position: 'bottom-right',
        })
      })
  }

  return {
    getRedeems,
    tableColumns,
    perPage,
    currentPage,
    totalRedeems,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refRedeemListTable,

    refetchData,

    // Extra Filters
    brandFilter,
    merchantFilter,
    codeFilter,
    refidFilter,
  }
}
